import { useState, useCallback, FocusEventHandler } from 'react'
import Select from 'react-select'
import { Box, BoxProps } from 'theme-ui'
import { ChevronDownIcon } from 'components/Icon'
import { noop } from 'utils'
import { StylesConfig } from 'react-select'
import theme from 'theme'
import { customSelectStyles } from './styles'

export const selectStyles: StylesConfig<any, any> = {
  option: (base) => ({
    ...base,
    color: theme.colors.text,
  }),
  indicatorSeparator: () => ({
    border: 0,
  }),
  control: (base) => ({
    ...base,
    minHeight: 'none',
    border: 0,
    backgroundColor: 'transparent',
    borderRadius: 0,
    boxShadow: 'none',
    cursor: 'pointer',
  }),
  menuList: (base) => ({
    ...base,
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes[0],
  }),
  valueContainer: (base) => ({
    ...base,
    fontFamily: theme.fonts.body,
    fontSize: theme.fontSizes[0],
  }),
}

export type SelectOption = {
  label: string
  value: string
}
export type GenericSelectProps = {
  id: string
  name: string
  options: SelectOption[]
  value?: SelectOption['value']
  disabled?: boolean
  tabIndex?: string | null | undefined | number
  sx?: BoxProps['sx']
  onChange?: (value: SelectOption['value']) => void
  onBlur?: FocusEventHandler
}

const DropdownIndicator = () => (
  <Box sx={{ width: 20, height: 20 }}>
    <ChevronDownIcon />
  </Box>
)

export const GenericSelect = ({
  id,
  name,
  value,
  options,
  tabIndex,
  disabled = false,
  sx = {},
  onChange = noop,
  onBlur = noop,
}: GenericSelectProps) => {
  const selected = options.find((option) => value === option.value)
  const [focused, setFocused] = useState(false)
  const handleOnChange = useCallback(
    (selectedOption: SelectOption) => {
      onChange(selectedOption.value)
    },
    [onChange]
  )

  const handleBlur = ((evt) => {
    onBlur(evt)
    setFocused(false)
  }) as FocusEventHandler

  return options.length ? (
    <Box
      sx={{
        p: 10,
        boxSizing: 'border-box',
        bg: 'oldlace',
        width: '100%',
        border: '2px solid oldlace',
        borderRadius: 8,
        boxShadow: focused ? '0 0 0 2px #ffc436' : 'none',
        opacity: disabled ? 0.6 : 1,
        ...sx,
      }}>
      <Select
        id={id}
        aria-label={`select-${name}`}
        name={name}
        value={selected}
        options={options}
        getOptionLabel={(option) => `${option.label}`}
        components={{ DropdownIndicator }}
        styles={customSelectStyles}
        theme={(t) => ({
          ...t,
          colors: {
            ...t.colors,
            primary: theme.colors.primary,
            primary50: theme.colors.darkyellow,
            primary25: theme.colors.oldlace,
          },
        })}
        tabIndex={`${tabIndex}`}
        isDisabled={disabled}
        onChange={handleOnChange}
        onFocus={() => setFocused(true)}
        onBlur={handleBlur}
        isSearchable
      />
    </Box>
  ) : null
}
